import { AuthApi } from "@/api/auth";
import { ResetPasswordRequest } from "@/api/auth/types";
import { ROUTE } from "@/utils";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const useResetPassword = () => {
  const navigate = useNavigate();

  const { mutate: resetPassword, isPending: isResetPasswordLoading } = useMutation({
    mutationFn: (body: ResetPasswordRequest) => AuthApi.resetAffiliatePassword(body),
    onSuccess: () => {
      toast.success("Password reset successfully!");
      navigate(ROUTE.AUTH_LOGIN);
    },
    onError: (error) => {
      toast.error(error);
    },
  });

  return { resetPassword, isResetPasswordLoading };
};
